import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed785d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "placeholder", "maxlength"]

import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTextForm',
  props: {
  type: {
    type: String as PropType<HTMLInputElement['type']>,
    default: 'text',
  },
  placeholder: {
    type: String as PropType<HTMLInputElement['placeholder']>,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: Number as PropType<HTMLInputElement['maxLength']>,
    default: undefined,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const value = computed({
  get: () => props.modelValue,
  set: (value) => {
    value = value.replace(/</g, '＜');
    value = value.replace(/>/g, '＞');
    emit('update:modelValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["base_text_form", { 'is-error': __props.isError }]),
    type: props.type,
    placeholder: props.placeholder,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    maxlength: props.maxlength
  }, null, 10, _hoisted_1)), [
    [_vModelDynamic, _unref(value)]
  ])
}
}

})